import React from 'react';
import HospitalHeader from './HospitalHeader';

/** Full-screen shell for a rotation tool: hospital header, Back, subtitle, content */
const ToolScreen = ({ hospital, subtitle, onBack, children }) => (
  <div className="max-w-md mx-auto bg-gray-50 dark:bg-gray-900 min-h-screen">
    <HospitalHeader hospital={hospital} subtitle={subtitle} onBack={onBack} />
    <div className="p-6">{children}</div>
    <div className="h-8" />
  </div>
);

export default ToolScreen;
